export enum WSApi {
  Logout = 'account.log_out',
  DownloadAppZip = 'application.download_shareable_zip',
  DownloadPlaylistZip = 'playlist.download_shareable_zip',
  DownloadTracks = 'admin.download_all_tracks_info_in_csv',
}
